import template from './WidgetHelpCenterView.html';
import { WidgetHelpDeskController } from './WidgetHelpCenterController';
export const WidgetHelpCenterComponent = {
    require: {
        ngModel: '?ngModel',
    },
    controller: WidgetHelpDeskController,
    controllerAs: '$ctrl',
    template,
};
